/** Round a data maximum up to 1, 2 or 5 × 10ⁿ so axis scales read naturally. */
export function niceMax(value: number): number {
  if (!Number.isFinite(value) || value <= 0) return 1;
  const exponent = 10 ** Math.floor(Math.log10(value));
  const fraction = value / exponent;
  return (fraction <= 1 ? 1 : fraction <= 2 ? 2 : fraction <= 5 ? 5 : 10) * exponent;
}

/**
 * SVG paths in a 0..(n-1) × 0..100 box. Null points break the line (and the area) so a host
 * restart or a gap in sampling never draws a false slope.
 */
export function chartPaths(values: readonly (number | null)[], max: number) {
  const y = (v: number) => (100 - (Math.min(v, max) / max) * 96).toFixed(2);
  let line = '',
    area = '',
    run: number[] = [];
  const flush = () => {
    if (!run.length) return;
    const first = run[0]!,
      last = run.at(-1)!;
    const points = run.map((i) => `${i} ${y(values[i]!)}`);
    // A lone point gets a short tick so it is still visible.
    if (run.length === 1) points.push(`${first + 0.35} ${y(values[first]!)}`);
    line += `M${points.join(' L')}`;
    area += `M${first} 100 L${points.join(' L')} L${run.length === 1 ? first + 0.35 : last} 100 Z`;
    run = [];
  };
  values.forEach((value, i) => {
    if (value == null || !Number.isFinite(value)) flush();
    else run.push(i);
  });
  flush();
  return { line, area };
}
